module.exports = __webpack_public_path__ + "img/typography.cdecec82.svg";